/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestUpdateRewardsProvider } from '../model/models';
import { ApiResponseRewardsProvider } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface RewardsProviderServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     */
    rewardsProviderControllerGetGlobalRewardsProvider0(extraHttpRequestParams?: any): Observable<ApiResponseRewardsProvider>;

    /**
     * 
     * 
     */
    rewardsProviderControllerGetGlobalRewardsProvider1(extraHttpRequestParams?: any): Observable<ApiResponseRewardsProvider>;

    /**
     * 
     * 
     * @param internalId 
     */
    rewardsProviderControllerGetRewardsProviderByInternalId0(internalId: string, extraHttpRequestParams?: any): Observable<ApiResponseRewardsProvider>;

    /**
     * 
     * 
     * @param internalId 
     */
    rewardsProviderControllerGetRewardsProviderByInternalId1(internalId: string, extraHttpRequestParams?: any): Observable<ApiResponseRewardsProvider>;

    /**
     * 
     * 
     * @param apiRequestUpdateRewardsProvider 
     */
    rewardsProviderControllerUpdateRewardsProvider0(apiRequestUpdateRewardsProvider: ApiRequestUpdateRewardsProvider, extraHttpRequestParams?: any): Observable<ApiResponseRewardsProvider>;

    /**
     * 
     * 
     * @param apiRequestUpdateRewardsProvider 
     */
    rewardsProviderControllerUpdateRewardsProvider1(apiRequestUpdateRewardsProvider: ApiRequestUpdateRewardsProvider, extraHttpRequestParams?: any): Observable<ApiResponseRewardsProvider>;

}
